/**
 * Marks each record in turn, in the order given. The marks are independent: one failing neither stops the rest nor
 * undoes those before it, so the caller can say exactly which records are now confidential.
 */
export const markConfidentialInOrder = async <Target>(
  targets: readonly Target[],
  mark: (target: Target) => Promise<unknown>
): Promise<{ marked: Target[]; failed: Target[] }> => {
  const marked: Target[] = []
  const failed: Target[] = []
  for (const target of targets) {
    try {
      await mark(target)
      marked.push(target)
    } catch {
      failed.push(target)
    }
  }
  return { marked, failed }
}
